import { formschema } from "../form/dataform";

/** 专业对口岗位加载表单 */
export const majorRelatedPositionLoadForm = (signForm: formschema['data'], data?: any, is_disable = false) => {
    const collegeid = localStorage.getItem('collegeid')
    // 河职专用
    if (!['5ab99b55d041fd4014a3b8f4','5e684b0395017e22b8929202'].includes(collegeid as string)) return
    const index = signForm.findIndex(v => v.field === 'is_major_match')
    const index2 = signForm.findIndex(v => v.field === 'major_related_position')
    // 存在专业是否对口字段且不存在对口岗位字段
    if (!~index || ~index2) return
    const isMajorMatchFileld = signForm[index]
    signForm.splice(index, 0, {
        control_type: 'dropdown',
        field: 'major_related_position',
        is_disable: isMajorMatchFileld.is_disable,
        is_talent_view: true,
        lockvalue: data?.major_related_position,
        name: '对口岗位',
        prompt_msg: '',
        required: true || isMajorMatchFileld.required,// ?不跟着专业是否对口走？？？
        dict_type: 'major_related_position',
    })
    isMajorMatchFileld.is_disable = true

    console.log('专业对口岗位加载表单', collegeid, signForm, index, index2)
}